export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, { ...init, headers: { ...(init?.headers || {}) } })
  const ct = res.headers.get('content-type') || ''
  if (!res.ok) {
    let msg = `Request failed (${res.status})`
    try {
      if (ct.includes('application/json')) msg = (await res.json())?.error || msg
      else msg = await res.text()
    } catch {}
    throw new Error(msg)
  }
  if (ct.includes('application/json')) return res.json()
  // @ts-expect-error
  return res.text()
}
